import styled, { css } from 'styled-components';

import { Flex } from '@rover/kibble/core';
import MQ from '@rover/kibble/styles/MediaQuery';

// eslint-disable-next-line rover/prefer-kibble-components
export const NoResultsWrapper = styled(Flex)`
  gap: ${({ theme }) => theme.space['4x']};
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding-right: ${({ theme }) => theme.space['4x']};
  padding-left: ${({ theme }) => theme.space['4x']};

  ${({ theme }) => css`
    justify-content: flex-start;
    margin-top: ${theme.space['32x']};

    ${MQ.TABLET_DOWN.toString()} {
      justify-content: center;
      margin-top: initial;
    }
  `}
`;
